import { cn } from "@babackapp/customer-ui/lib/utils";
import { AnimatePresence, motion } from "motion/react";
import { useLocation, useOutlet } from "react-router-dom";
import { LineItemBar } from "./line-item-bar";
import { LineItemStepper } from "./line-item-stepper";

export function LineItemLayout() {
  const { pathname } = useLocation();
  const parts = pathname.split("/");
  const group = parts[parts.length - 3];
  const step = parts[parts.length - 1];
  const outlet = useOutlet();

  return (
    <div className="w-full flex flex-col flex-1 min-h-0">
      <AnimatePresence mode="wait">
        {group === "line-item" && step !== "confirmation" && (
          <motion.div
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1, transition: { type: "spring" } }}
            exit={{ y: -50, opacity: 0 }}
            // Shares its row with the widget chrome (language + close), pinned
            // top-right on the same 32px band. The stepper stretches to whatever
            // width it is given (its dividers are `flex-1`), so the clearance is
            // the padding: pr-32 lands the last step ~35px short of the chrome,
            // and still leaves far more than the three steps need.
            className={cn(
              "absolute top-6 left-8 right-6 z-10 flex min-h-8 items-center bg-background rounded-lg pr-32 @container",
            )}
          >
            <LineItemStepper />
          </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence mode="popLayout">
        {step !== "line-item" ? (
          <LineItemBar />
        ) : null}
      </AnimatePresence>
      <AnimatePresence mode="wait" propagate>
        <motion.div
          key={pathname}
          className={cn(
            "flex-1 min-h-0 overflow-y-auto overflow-x-hidden isolate",
            step !== "line-item" && "pb-24",
          )}
        >
          {outlet}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
